import { SystemStyleObject, Theme } from "@mui/system";

export default function addStylesForDevices(
  queryResult: boolean,
  defaultStyles: SystemStyleObject<Theme>,
  overrides: SystemStyleObject<Theme>
): SystemStyleObject<Theme> {
  let styles: SystemStyleObject<Theme> = defaultStyles;
  if (queryResult) {
    styles = {
      ...defaultStyles,
      ...overrides,
    };
  }
  return styles;
}
